import * as Yup from "yup";

const AdminBulletinSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  bulletin: Yup.string().required("Bulletins is required"),
});

export default AdminBulletinSchema;
